
<template>
  <vs-sidebar click-not-close parent="#tranksaksi-app" :hidden-background="true" class="full-vs-sidebar tranksaksi-view-sidebar items-no-padding" v-model="isSupplierActive" position-right>
    <div class="px-0 sm:pb-6 h-full tranksaksi-area-loading">
      <div class="flex flex-wrap items-center justify-between md:px-8 px-6 py-5 d-theme-dark-bg tranksaksi-header bg-primary">
        <h5 class="text-white">Tambah Supplier</h5>
        <feather-icon :icon="$vs.rtl ? 'XIcon' : 'XIcon'" @click="supplierAddClose" class="cursor-pointer mr-4" svg-classes="text-white w-6 h-6"></feather-icon>
      </div>

      <component :is="scrollbarTag" class="tranksaksi-scroll-area md:p-8 p-6 mt-base" :settings="settings" :key="$vs.rtl">

        <div class="vx-col w-full sm:w-3/4 items-center sm:flex-row flex-col mx-auto">
        
          <vs-row>
            <vs-col vs-align="center" vs-w="12">
              <vs-input label="Kontak" v-model="dataKontak" class="mt-5 w-full" name="item-kontak" v-validate="'required'" />
              <span class="text-danger text-sm" v-show="errors.has('item-kontak')">{{ errors.first('item-kontak') }}</span>
            </vs-col>
          </vs-row>

          <vs-divider class="mt-base">Informasi Umum</vs-divider>

          <vs-row>
            <vs-col vs-align="center" vs-w="6" class="pr-2">
              <vs-input label="Email" v-model="dataEmail" class="mt-2 w-full" name="item-email" v-validate="'email'"/>
            </vs-col>
            <vs-col vs-align="center" vs-w="6">
              <vs-input label="Telepon" v-model="dataTelepon" class="mt-2 w-full" name="item-telepon" v-validate="'numeric'"/>
            </vs-col>
          </vs-row>

          <span class="text-sm mt-4">Alamat</span>
          <vs-textarea v-model="dataAlamat"  class="mt-1 w-full"/>


          <vs-divider class="mt-base">Rekening</vs-divider>

          <vs-row>

            <vs-col vs-align="center" vs-w="4">
              <vs-select
                label="Bank"
                v-model="dataBank"
                class="mt-2 w-full"
                >
                  <vs-select-item value="" text="Tidak ada"/>
                  <vs-select-item :key="itemx.id" :value="itemx.id" :text="itemx.name" v-for="itemx in listBank"/>
              </vs-select>
            </vs-col>

            <vs-col vs-align="center" vs-w="2">
              <vs-button class="py-3 mt-8" @click.stop="tambahBank=true" >+</vs-button>
            </vs-col>

            <vs-col vs-align="center" vs-w="6" class="pr-2">
              <vs-input label="Atas Nama" v-model="dataAtasNama" class="mt-2 w-full" />
            </vs-col>

            <vs-col vs-align="center" vs-w="12" class="pr-2">
              <vs-input label="Nomor Rekening" v-model="dataRekening" class="mt-2 w-full"  v-validate="'numeric'"/>
            </vs-col>
          </vs-row>

          <div class="vx-row mt-6">
          <div class="vx-col w-1/2">
            <div class="flex flex-wrap items-center">
              <vs-button class="" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
            </div>
          </div>
          <div class="vx-col w-1/2">
            <div class="flex flex-wrap items-center justify-end">
              <vs-button type="border" color="danger" @click="isSupplierActiveLocal = false">Cancel</vs-button>
            </div>
          </div>
          </div>

        </div>
      </component>
    </div>

    <vs-prompt
      color="success"
      title="Tambah Bank"
      @accept="bankAdd"
      @close="close"
      :active.sync="tambahBank"
      style="z-index: 52011;">
      <div class="con-exemple-prompt">
        <vs-input placeholder="Nama Bank" data-vv-name="addbank" name="addbank" v-validate="'required'" v-model="addBank" class="w-full mb-base"/>
        <span class="text-danger text-sm" v-show="errors.has('addbank')">{{ errors.first('addbank') }}</span>
        <vs-input placeholder="Kode bank" data-vv-name="addkodebank" name="addkodebank" v-validate="'required'" v-model="addkodebank"/>
        <span class="text-danger text-sm" v-show="errors.has('addkodebank')">{{ errors.first('addkodebank') }}</span>
      </div>
    </vs-prompt>

  </vs-sidebar>

</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { mapGetters } from 'vuex'

export default {
  props: {
    isSupplierActive: {
      type: Boolean,
      required: true
    }
  },
  components: {
    VuePerfectScrollbar,
  },
  data () {
    return {

      dataId: null,
      dataKontak: null,
      dataGroup: '217',
      dataParent: 0,
      dataEmail: null,
      dataTelepon: null,
      dataAlamat: null,
      dataBank: '',
      dataAtasNama: null,
      dataRekening: null,

      listBank: [],

      addBank: null,
      addkodebank: null,
      tambahBank: false,

      settings: {
        maxScrollbarLength: 80,
        wheelSpeed: .80
      }
    }
  },
  watch: {
    isSupplierActive (val) {
      
      let configs = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }

      this.axios.get('/term-list/bank', configs)
      .then((response) => {
        let {data} = response.data
        this.listBank = data
      })
      .catch((error) => {
        let data = error.data
        this.listBank = data
      })

      if (!val) return
      this.initValues()
      this.$validator.reset()
    }
  },
  computed: {
    isSupplierActiveLocal: {
      get () {
        return this.isSupplierActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSupplier')
          this.$validator.reset()
          this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.dataKontak && this.dataGroup && this.dataBank
    },
    validateBank() {
      return !this.errors.any() && this.addBank !== null && this.addkodebank !== null
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag },
    ...mapGetters({
      user : 'auth/user',
    }),
  },
  mounted(){
  },
  beforeDestroy () {
  },
  methods: {
    initValues () {
      this.dataId = null
      this.dataKontak = null
      this.dataGroup = '217'
      this.dataParent = 0
      this.dataEmail = null
      this.dataTelepon = null
      this.dataAlamat = null
      this.dataBank = ''
      this.dataAtasNama = null
      this.dataRekening = null
    },
    close() {
      this.$emit('closed', false)
    },
    supplierAddClose() {
      this.$emit('closeSupplier')
    },
    bankAdd() {

      this.$vs.loading()
      let configs = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }
      let formData = {
        name : this.addBank,
        term_group: 0,
        parent: 0,

        meta : {
          kode: this.addkodebank,
        },

        taxonomy: 'bank'
      }

      this.axios.post('/term-add', formData, configs)
      .then((response) => {
        this.listBank = []
        this.addBank = null
        this.addkodebank = null
        this.loadBank()

        this.$vs.notify({
          title: response.message,
          color  : 'success',
          text  : 'Bank telah bertambah',
        })
        this.$vs.loading.close()

      })
      .catch((error) => {
        this.$vs.loading.close()
        let { data } = error.response

        this.$vs.notify({
          title: 'Error',
          text: data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })

    },
    loadBank () {
      let configs = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }
      this.axios.get('/term-list/bank', configs)
      .then((response) => {
        let {data} = response.data
        this.listBank = data
      })
      .catch((error) => {
        let data = error.data
        this.listBank = data
      })
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const obj = {
            id: this.dataId,
            name: this.dataKontak,
            term_group: '217',
            parent: this.dataParent,

            meta : {
              email: this.dataEmail,
              telepon: this.dataTelepon,
              alamat: this.dataAlamat,

              bank: this.dataBank,
              atasnama: this.dataAtasNama,
              rekening: this.dataRekening,
            },

            taxonomy: 'kontak'
          }
          if (this.dataId !== null && this.dataId >= 0) {
            this.$store.dispatch('supplier/updateKontak', obj)
          } else {
            delete obj.id
            this.$store.dispatch('supplier/addKontak', obj)
          }
          this.$emit('closeSupplier')
          this.initValues()
        }
      })
    }
  }
}
</script>
